import React, { useState, useEffect } from 'react';
import { Card, Box, Stack, Typography, CardContent, TextField, Button, Alert } from '@mui/material';
import ikigaiLogo from '../assets/logo-edited.png';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import authService from '../services/auth_service';
import Loading from '../components/Loading';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const { register, handleSubmit, watch, formState: { errors } } = useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [userRole, setUserRole] = useState(null);;

  useEffect(() => {
    const userData = authService.getUserDataFromLocalStorage();
    if (userData && userData.role) {
      setUserRole(userData.role);
    }
  }, []);

  useEffect(() => {
    if (userRole === 5) {
      navigate('/dashboard/management/user');
    } else if (userRole === 2) {
      navigate('/dashboard/management/feedback');
    }
  }, [userRole, navigate]);


  const handleLogin = async (loginData) => {
    const response = await authService.login(loginData);

    if (!response.data) {
      setErrorMessage(response.message);
      setIsError(true)
      setIsLoading(false)
      return
    }

    const {data, token} = response.data;

    // If login success
    console.log(response.data);

    if(token) {
      authService.setTokenToLocalStorage(token)
      authService.setUserDataToLocalStorage(data)

      if (data.role){
        setUserRole(data.role);
      }
    }
  };

  const onSubmit = (data) => {
    handleLogin(data);
    setIsLoading(true)
    setErrorMessage("")
    setIsError(false)
  }



  return (
    <Box sx={{
      width: "100%",
      height: "800px",
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#1C1C1E',
      fontFamily: 'inherit'
    }}>
      <Loading isOpen={isLoading} />
      <img src={ikigaiLogo} alt="ikigai logo" />
      <Card sx={{ minWidth: '500px' }}>
        <CardContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Stack gap={2} sx={{ padding: '20px' }}>
              <Stack>
                <Typography component='p' fontSize={14} color="#6d6d64">Welcome back!</Typography>
                <Typography component='h1' fontSize={24}>Login Admin</Typography>
              </Stack>
              {
                isError &&
                (<Alert severity="error" >{errorMessage}</Alert>)
              }
              <TextField id='username-field' label="Username" variant='outlined' {...register('email')} />
              <TextField id='password-field' type='password' label="Password" variant='outlined' {...register('password')} />
              <Button variant='contained' style={{ backgroundColor: '#C6D22D' }} type='submit'>Login</Button>
            </Stack>
          </form>
        </CardContent>
      </Card>
    </Box>
  )
};

export default Login